"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeOverlap = void 0;
const turf_1 = require("@turf/turf");
const geojson_precision_1 = __importDefault(require("geojson-precision"));
const lodash_1 = __importDefault(require("lodash"));
const geojson_converters_1 = require("../geojson-converters");
// To increase the likelihood that the intersect operation will succeed,
// we can work with reduced precision.
// Degrees east/west are always less than degrees north/south.
// One degree north/south is equal to 111,139 meters. Let's say that one
// degree is ~100,000 meters, or one meter is 1e-5 degrees.
// So one centimeter precision is about 1e-7 of a degree.
const CROP_PRECISION_DP = 7;
/**
 * Remove the overlap of of features.
 *
 * @param inputFeatureCollection Features to operate on
 * @returns A new set of features without overlap
 */
function removeOverlap(inputFeatureCollection) {
    const reducedPrecision = (0, geojson_precision_1.default)(inputFeatureCollection, CROP_PRECISION_DP);
    // ordered by area
    const ordered = lodash_1.default.orderBy(reducedPrecision.features, (f) => (0, turf_1.area)(f));
    const result = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ordered.length; i++) {
        let newFeatureI = ordered[i];
        // eslint-disable-next-line no-plusplus
        for (let j = i + 1; j < ordered.length; j++) {
            newFeatureI = newFeatureI && (0, turf_1.difference)(newFeatureI, ordered[j]);
        }
        if (newFeatureI !== null) {
            result.push(newFeatureI);
        }
    }
    return (0, geojson_converters_1.flattenMultiFeatureCollection)((0, turf_1.featureCollection)(result));
}
exports.removeOverlap = removeOverlap;
